import { Seo } from '../components/Seo';
import { Breadcrumbs } from '../components/Breadcrumbs';
import { ArticleCard } from '../components/ArticleParts';
import { NewsletterForm } from '../components/NewsletterForm';
import { magazineArticles } from '../content/magazine';

export default function Magazin() {
  return (
    <>
      <Seo
        title="Felix Genuss Magazin | Rezepte, Wissen & Hundegenuss"
        description="Rezepte, Zutatenwissen, Tipps und Geschichten rund um Felix und die Welt der vierbeinigen Feinschmecker."
        path="/magazin"
      />
      <Breadcrumbs items={[{ label: 'Startseite', href: '/' }, { label: 'Magazin' }]} />

      <div className="container-site max-w-3xl pt-10">
        <p className="eyebrow">Das Magazin</p>
        <h1 className="mt-3 font-serif text-4xl font-bold leading-[1.05] tracking-tight sm:text-5xl">
          Felix Genuss Magazin
        </h1>
        <p className="mt-6 leading-relaxed text-brand-brown/85">
          Rezepte, Zutatenwissen, Tipps und Geschichten rund um Felix und die Welt der vierbeinigen Feinschmecker.
        </p>
      </div>

      <section className="container-site mt-14" aria-label="Magazinartikel">
        <div className="grid gap-6 sm:grid-cols-2">
          {magazineArticles.map((a) => (
            <ArticleCard key={a.slug} article={a} basePath="/magazin" />
          ))}
        </div>
      </section>

      <section className="mt-16 bg-brand-brown py-14 text-brand-cream sm:py-20" aria-labelledby="newsletter-heading">
        <div className="container-site text-center">
          <p className="text-xs font-semibold uppercase tracking-[0.22em] text-brand-gold sm:text-sm">Newsletter</p>
          <h2 id="newsletter-heading" className="mt-3 font-serif text-3xl font-bold leading-tight text-brand-cream sm:text-4xl">
            Neues aus Felix' Küche
          </h2>
          <p className="mx-auto mt-4 max-w-xl leading-relaxed text-brand-cream/85">
            Neue Rezepte, Wissen und Geschichten von Felix direkt ins Postfach.
          </p>
          <NewsletterForm />
        </div>
      </section>
    </>
  );
}
